import * as ActionTypes from '../SetDisplayMode';

export function setDisplayMode(data) {
    return {type: ActionTypes.SET_DISPLAY_MODE, data};
}



// WEBPACK FOOTER //
// ./js/actions/creators/SetDisplayMode.js